import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as r } from "../../core/accessorSupport/decorators/subclass.js";
import o from "./mixins/MediaInfo.js";
import s from "./support/ImageMediaInfoValue.js";

var _a;

var i = _a = /*#__PURE__*/function (_o) {
  _inherits(a, _o);

  var _super = _createSuper(a);

  function a(e) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, e), _this.refreshInterval = null, _this.type = "image", _this.value = null;
    return _this;
  }

  _createClass(a, [{
    key: "clone",
    value: function clone() {
      return new _a({
        altText: this.altText,
        title: this.title,
        caption: this.caption,
        refreshInterval: this.refreshInterval,
        value: this.value ? this.value.clone() : null
      });
    }
  }]);

  return a;
}(o);

e([t({
  type: Number,
  json: {
    write: !0
  }
})], i.prototype, "refreshInterval", void 0), e([t({
  type: ["image"],
  readOnly: !0,
  json: {
    read: !1,
    write: !0
  }
})], i.prototype, "type", void 0), e([t({
  type: s,
  json: {
    write: !0
  }
})], i.prototype, "value", void 0), i = _a = e([r("esri.popup.content.ImageMediaInfo")], i);
var p = i;
export { p as default };